import { Logger } from "@nestjs/common";

export class RechargeAccessTokenManager {

  private readonly accessTokens: string[];

  private currTokenIndex: number;

  private readonly logger = new Logger(RechargeAccessTokenManager.name);

  constructor(
    accessTokens: string[],
  ) {
    if (!accessTokens || !accessTokens.length) {
      throw new Error("No apiKey provided for RechargeAccessTokenManager");
    }
    if (accessTokens.some((it) => !it.trim())) {
      throw new Error(`Empty apiKey provided for RechargeAccessTokenManager: ${JSON.stringify(accessTokens)}`);
    }
    this.accessTokens = accessTokens;
    // Start from a random key to reduce the chances of every instance using the same key at the same time
    this.currTokenIndex = Math.floor(Math.random() * this.accessTokens.length);
    this.logger.log(
      `ReCharge token manager started with ${this.accessTokens.length} keys (currently on key ${this.currTokenIndex})`,
      {
        accessTokensLength: this.accessTokens.length,
        currTokenIndex: this.currTokenIndex,
      },
    );
  }

  public getNextAccessToken(): string {
    const retKey = this.accessTokens[this.currTokenIndex];
    this.currTokenIndex = (this.currTokenIndex + 1) % this.accessTokens.length;
    return retKey;
  }

}
